// Applicant/employee work authorization status (per Mudassir's Jun-16 hiring
// baseline handoff). Replaces the old "workAuthorizationUS" boolean.
export const WorkAuthorizationStatusEnum = Object.freeze({
  NotAuthorized: 0,
  USCitizen: 1,
  GreenCardPermanentResident: 2,
  OPT: 3,
  CPT: 4,
  H1B: 5,
  OtherWorkAuthorization: 6,
});

export const WorkAuthorizationStatusEnumLabel = Object.freeze({
  [WorkAuthorizationStatusEnum.NotAuthorized]: "Not Authorized",
  [WorkAuthorizationStatusEnum.USCitizen]: "US Citizen",
  [WorkAuthorizationStatusEnum.GreenCardPermanentResident]: "Green Card / Permanent Resident",
  [WorkAuthorizationStatusEnum.OPT]: "OPT",
  [WorkAuthorizationStatusEnum.CPT]: "CPT",
  [WorkAuthorizationStatusEnum.H1B]: "H1B",
  [WorkAuthorizationStatusEnum.OtherWorkAuthorization]: "Other Work Authorization",
});

// Dropdown options for the application form. NotAuthorized is intentionally
// excluded — that case is handled by the "are you authorized?" Yes/No step.
export const WorkAuthorizationApplyOptions = [
  WorkAuthorizationStatusEnum.USCitizen,
  WorkAuthorizationStatusEnum.GreenCardPermanentResident,
  WorkAuthorizationStatusEnum.OPT,
  WorkAuthorizationStatusEnum.CPT,
  WorkAuthorizationStatusEnum.H1B,
  WorkAuthorizationStatusEnum.OtherWorkAuthorization,
].map((value) => ({ value, label: WorkAuthorizationStatusEnumLabel[value] }));
